import { FiltrosOrdenNoProgramada, OrdenNoProgramadaPage } from '../../model/orientaciones-no-programadas/orden-servicio-detalle';

/**
 * Puerto Abstracto: OrdenNoProgramadaRepository
 *
 * Define el contrato para búsqueda de órdenes no programadas.
 * Usa Keyset/Cursor Pagination — skill: paginacion.
 * Migrado desde: OrdenServicioDetalleFacade.java
 *
 * @author Sura - Migración GWT a Angular
 */
export abstract class OrdenNoProgramadaRepository {

  /**
   * Busca órdenes no programadas según filtros con cursor pagination.
   *
   * @param filtros Criterios de búsqueda del formulario
   * @param cursor  Cursor de la página (null = primera página)
   * @param size    Registros por página
   * @param direction Dirección de navegación: NEXT | PREVIOUS
   * @returns Página de resultados con cursores
   *
   * @legacy pck_psc_programar_ordenes.sp_psc_consultar_ordenes
   */
  abstract buscarOrdenes(
    filtros: FiltrosOrdenNoProgramada,
    cursor: string | null,
    size: number,
    direction: 'NEXT' | 'PREVIOUS'
  ): Promise<OrdenNoProgramadaPage>;
}
